// Pure per-cup and savings math. Browser global RootedPack, or CommonJS for node --test.
(function (root) {
  function boxesFor(packName, map) {
    var key = String(packName || '').trim().toLowerCase();
    var pairs = String(map || '').split(',');
    for (var i = 0; i < pairs.length; i++) {
      var kv = pairs[i].split(':');
      if (kv[0] && kv[0].trim().toLowerCase() === key) return parseInt(kv[1], 10) || 1;
    }
    return 1;
  }
  function perCupCents(priceCents, boxes, bagsPerBox) {
    return Math.round(priceCents / (boxes * bagsPerBox));
  }
  function savingsPercent(priceCents, singleCents, boxes) {
    var full = singleCents * boxes;
    if (!full || priceCents >= full) return 0;
    return Math.round((1 - priceCents / full) * 100);
  }
  // Variant for a pack card: same pack value, every other option as currently selected.
  // Falls back to the first variant of that pack (Single has no Half & Half).
  function variantForPack(variants, packIndex, packValue, selected) {
    var inPack = variants.filter(function (v) { return v.options[packIndex] === packValue; });
    var exact = inPack.filter(function (v) {
      return v.options.every(function (o, i) { return i === packIndex || o === selected[i]; });
    })[0];
    return exact || inPack[0] || null;
  }
  // The Single variant that "Save N%" is measured against: boxes == 1 and every other
  // option at its base (first) value, i.e. Single / All Green. Falls back to any 1 box variant.
  function referenceVariant(variants, cfg) {
    var singles = variants.filter(function (v) {
      return boxesFor(v.options[cfg.packIndex], cfg.boxesMap) === 1;
    });
    var base = singles.filter(function (v) {
      return v.options.every(function (o, i) { return i === cfg.packIndex || o === (cfg.baseOptions || [])[i]; });
    })[0];
    return base || singles[0] || null;
  }
  // Everything one pack card displays for the current selection (float maths, no truncation).
  function cardFigures(variants, cfg, packValue, selected) {
    var v = variantForPack(variants, cfg.packIndex, packValue, selected);
    if (!v) return null;
    var boxes = boxesFor(packValue, cfg.boxesMap);
    var ref = referenceVariant(variants, cfg);
    return {
      variantId: v.id,
      priceCents: v.price,
      boxes: boxes,
      cups: boxes * cfg.bagsPerBox,
      perCupCents: perCupCents(v.price, boxes, cfg.bagsPerBox),
      savePercent: ref ? savingsPercent(v.price, ref.price, boxes) : 0,
      // Strikethrough figure: Single / All Green x boxes. 0 when there is nothing to strike.
      compareCents: ref && boxes > 1 && ref.price * boxes > v.price ? ref.price * boxes : 0
    };
  }
  // True when the selected variant contains mint (All Mint or Half & Half).
  function showsMint(options) {
    return (options || []).some(function (o) {
      var k = String(o).trim().toLowerCase();
      return k === 'all mint' || k === 'half & half' || k === 'mixed';
    });
  }
  // Free gift lock state for a pack value. qualifying is the settings string
  // ("Ritual, Household") or an array. Case and spacing insensitive.
  function giftState(pack, qualifying) {
    var list = Array.isArray(qualifying) ? qualifying : String(qualifying || '').split(',');
    var key = String(pack || '').trim().toLowerCase();
    var hit = key !== '' && list.some(function (q) { return String(q).trim().toLowerCase() === key; });
    return hit ? 'unlocked' : 'locked';
  }
  // The pack value a locked gift row jumps to: the first qualifying pack that exists
  // in the product's pack values (preserving the qualifying list order), else null.
  function giftTarget(qualifying, packValues) {
    var list = Array.isArray(qualifying) ? qualifying : String(qualifying || '').split(',');
    for (var i = 0; i < list.length; i++) {
      var k = String(list[i]).trim().toLowerCase();
      for (var j = 0; j < packValues.length; j++) {
        if (String(packValues[j]).trim().toLowerCase() === k && k !== '') return packValues[j];
      }
    }
    return null;
  }
  // Key of the tier thumbnail (assets/rooted-tier-{key}.png) for a pack and flavor mix:
  // 'ritual-half', 'starter-mint', 'household-green'. Single has no Half & Half, so that
  // combination falls back to 'single-green'. An unknown mix reads as green.
  function tierThumbKey(pack, mix) {
    var p = String(pack || '').trim().toLowerCase();
    var m = String(mix || '').trim().toLowerCase();
    var mixKey = m === 'all mint' ? 'mint' : (m === 'half & half' || m === 'mixed') ? 'half' : 'green';
    if (p === 'single' && mixKey === 'half') mixKey = 'green';
    return p + '-' + mixKey;
  }
  var api = {
    tierThumbKey: tierThumbKey,
    boxesFor: boxesFor, perCupCents: perCupCents, savingsPercent: savingsPercent,
    variantForPack: variantForPack, referenceVariant: referenceVariant,
    cardFigures: cardFigures, showsMint: showsMint,
    giftState: giftState, giftTarget: giftTarget
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.RootedPack = api;
})(this);
